
import { mixins, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { maska } from 'maska'
import cloneDeep from 'lodash/cloneDeep'
import { ACTION_AUDIENCE } from '@/store/actions'
import { IAudience } from '@/utils/types'
import AudienceMixin from '@/components/audience/mixins/AudienceMixin.vue'
import AudienceFilter from '@/components/audience/_partials/AudienceFilter.vue'
import CLoading from '@/components/common/ui/CLoading.vue'
import BaseFormDialogMixin from '@/components/common/mixins/BaseFormDialogMixin.vue'
import TestModeSelector from '@/components/common/ui/TestModeSelector.vue'

@Options({
  components: {
    AudienceMixin,
    AudienceFilter,
    CLoading,
    TestModeSelector,
  },
  directives: { maska },
  emits: ['update:saveModal', 'openActivityModal'],
})
export default class AudienceFormModal extends mixins(AudienceMixin, BaseFormDialogMixin) {
  @Prop()
  audience!: IAudience

  loading = true
  componentKey = 0
  form: IAudience = {
    _id: '',
    app_id: '',
    title: '',
    campaign_ids: [],
    campaign_names: '',
    traffic_source_ids: [],
    traffic_source_names: '',
    target_setting_ids: [],
    audience_size: 0,
    filter_condition: {
      date_range: { from: '', to: '' },
      answers: {},
    },
    is_auto_update: false,
    is_test_mode: false,
    is_fork: false,
    conditions: [],
  }

  errorMessage = ''

  get requiredRule() {
    const requiredRule = {
      audienceName: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.audience.audience_name'),
      }),
    }
    return requiredRule
  }

  get modalTitle() {
    return this.isNew ? this.$t('label.audience.add_new_audience') : this.$t('label.audience.edit_audience')
  }

  get targetSettings() {
    return this.$store.getters.targetSettings || []
  }

  handleLoading(val) {
    this.loading = val
  }

  onSubmit() {
    try {
      console.log('onSubmit')

      this.errorMessage = ''
      this.$refs.formRef
        .validate()
        .then(async (success: boolean) => {
          if (!success) {
            console.log('onSubmit error', this.errorMessage)

            return
          }
          console.log('onSubmit success')

          const isError = this.$refs.audience_filter.validate()
          if (!isError && !this.form.is_fork) {
            this.errorMessage = this.$t('validate.no_conditions_selected')
            console.log('onSubmit error', this.errorMessage)

            return
          }
          this.loading = true
          await this.doSave()
          this.loading = false
          this.visible = false
        })
        .catch((error: unknown) => {
          console.log('error', error)
        })
    } catch (error) {
      console.log('error', error)
    }
  }

  async doSave() {
    const { dispatch } = this.$store
    let message = null
    if (this.isNew) {
      this.form.app_id = this.selectedAppId
      if (this.form.is_test_mode) {
        this.form.title = '[TEST] ' + this.form.title
      }
      message = await dispatch(ACTION_AUDIENCE.ADD_NEW, {
        ...this.form,
      })
    } else {
      if (this.form.is_test_mode && this.form.title && !this.form.title.startsWith('[TEST] ')) {
        this.form.title = '[TEST] ' + this.form.title
      }
      message = await dispatch(ACTION_AUDIENCE.UPDATE, {
        ...this.form,
      })
    }
    if (message) {
      this.$q.notify({
        message: this.$t('messages.saved'),
        color: 'positive',
      })

      this.$emit('update:saveModal')
    }
  }

  mounted() {
    this.$nextTick(() => {
      this.$refs.formRef.validate()
    })
  }

  onClearOptionChange() {
    this.form.target_setting_ids = []
  }

  onOpenActivityModal(userId, from, to, isTestMode) {
    this.$emit('openActivityModal', userId, from, to, isTestMode)
  }

  async created() {
    this.loading = true
    this.form = { ...this.form, ...cloneDeep(this.audience) }
    this.parentForm = this.form as any
    this.initForm = cloneDeep(this.parentForm)

    await this.$nextTick(async () => {
      await this.$refs.audience_filter.loadDataFromServer()
    })
  }
}
